import i18next from 'i18next'

export const klasses = Object.freeze({
  'Contractor::Company': i18next.t('company.other'),
  'Contractor::Contract': i18next.t('contract.other'),
  'Contractor::Asset': i18next.t('asset.other'),
  'Account::Office': i18next.t('office.one'),
  Employee: i18next.t('employee.other'),
  'Request::ContractChange': i18next.t('request.contractChange'),
  'Request::ContractTermination': i18next.t('request.contractTermination'),
  User: i18next.t('user.other'),
  'Role': i18next.t('userRole.other'),
  'Attachment': i18next.t('attachment.other'),
  'Access': i18next.t('access_control.one'),
  'Visit': i18next.t('visit.one')
})
